import React from 'react';
import useTranslation from '@modules/hooks/useTranslation';
import { Mobile, PC } from '@components/MediaQuery';
import styles from '@styles/guide/useGuide.module.scss';

interface Props {
    type: 'STS' | 'TTS';
    setType: (type: 'STS' | 'TTS') => void;
}

const SetType = ({ type, setType }: Props) => {
    const { t } = useTranslation('guide');

    return (
        <ul className={styles.type_list}>
            <li className={`${styles.type_item} ${type === 'STS' ? styles.active : ''}`}>
                <button type="button" onClick={() => setType('STS')}>
                    <PC>{t('STS')}</PC>
                    <Mobile>STS</Mobile>
                </button>
            </li>
            <li className={`${styles.type_item} ${type === 'TTS' ? styles.active : ''}`}>
                <button type="button" onClick={() => setType('TTS')}>
                    <PC>{t('TTS')}</PC>
                    <Mobile>TTS</Mobile>
                </button>
            </li>
        </ul>
    );
};

export default SetType;
